import { datalabHttp } from '@dbl/services/common';

import type {
  IGetMenuDataRequest,
  IGetMenuLevelListRequest,
  IMenuResultDto,
  TGetMenuLevelListData,
} from './types';

/**
 * 获取左侧菜单列表（datalab 挂载在 globalpedia 菜单体系下）。
 *
 * 接口：`GET /api/v1/globalpedia_pc/listMenuV2`；存量：`getLeftMenuList`。
 */
export const getLeftMenuList: () => Promise<IMenuResultDto[]> = () =>
  datalabHttp('/api/v1/globalpedia_pc/listMenuV2', {
    method: 'get',
    formatData: (data: { menu_list?: { sub_menus: IMenuResultDto[] }[] }) => {
      if (!data) {
        return [];
      }
      return data.menu_list?.[0]?.sub_menus ?? [];
    },
  });

/**
 * 获取报表发布菜单树（发布弹窗选目录）。
 *
 * 接口：`POST /api/v1/datalab/getDashboardMenuInfo`；存量：`getMenuData`。
 */
export function getMenuData(params: IGetMenuDataRequest): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/getDashboardMenuInfo',
    method: 'post',
    data: params,
  });
}

/**
 * 拉取经分菜单层级列表（发布弹窗选目录层级）。
 *
 * 接口：`POST /api/v1/dashboard/menu/listUserLevel`；存量：`getLevelData`。
 */
export function getMenuLevelList(
  params: IGetMenuLevelListRequest,
): Promise<TGetMenuLevelListData> {
  return datalabHttp({
    url: '/api/v1/dashboard/menu/listUserLevel',
    method: 'post',
    data: params,
  });
}
